import { useQuery } from '@tanstack/react-query';

import { useEcomStoreSelector } from '@/data';
import { useSearchService } from '@/opensearch';

export const useProductsByIds = ({ ids }: { ids: string[] }) => {
  const { treez_store_name, customer_type } = useEcomStoreSelector([
    'treez_store_name',
    'customer_type',
  ]);
  const queryKey = ['productsByIds', treez_store_name, customer_type, ...ids];

  const { getProductsByIds } = useSearchService();

  const { data, isLoading, error, isError } = useQuery({
    queryKey,
    queryFn: async () => {
      const products = await getProductsByIds({ ids });

      return products;
    },
    enabled: !!ids.length,
  });

  return {
    error,
    isError,
    isLoading,
    products: data ?? [],
  };
};
